import {
  useClient,
  useDictionary,
  useOrder,
} from "@adamlip/okeoke.client";
import { Radio, RadioGroup, cn } from "@nextui-org/react";
import PaymentAgentParams from "components/PaymentAgentSelector/PaymentAgentParams";
import useBasket from "hooks/useBasket";
import { toast } from "react-hot-toast";
import { NumericFormat } from "react-number-format";
import { useNavigate, useParams } from "react-router-dom";
function PayTheOfflineOrder({ onSelectPayment, hideStartPayment }) {
  const { id } = useParams();
  const { getName, locations, selectedLocationUUID } = useClient();

  const { getValue } = useDictionary();
  const { paymentsNeeded, isReady, orderNumber, totalPrice, discountAmount } =
    useOrder(null, id);
  const navigate = useNavigate();
  const { selectedPayment, setSelectedPayment } =
    useBasket();

  const paymentAgents = locations?.[selectedLocationUUID]?.paymentAgents;

  const navigateToPayment = () => {
    let profileType = selectedPayment?.useOnline?.profileType;
    let paymentAgentID = selectedPayment?.paymentAgentID;
    console.log("navigateToPayment", profileType, paymentAgentID);
    if (profileType != null && paymentAgentID != null) {
      navigate(
        `/orderpay/${profileType.toLowerCase()}/${id}-${paymentAgentID}`
      );
    } else {
      toast.error("app_v2_invalidPaymentAgent");
    }
  };

  if (!isReady) return null;
  if (isReady && paymentsNeeded === 0)
    return <div className="payed-text">{getValue("app_v2_orderPayed")}</div>;

  return (
    <div className="payment-select-container w-full overflow-y-scroll pb-[150px]">
      <div className="payment-title">{getValue("app_v2_payments_title")}</div>
      {paymentAgents.filter((agent) => agent.agentType === "online").length ===
        0 && (
          <div className="no-payments">{getValue("app_v2_noPaymentAgents")}</div>
        )}
      <div className="px-4">
        <RadioGroup
          label={getValue("app_v2_paymentAgents")}
          value={selectedPayment?.paymentAgentID}
          onValueChange={(value) => {
            setSelectedPayment(
              paymentAgents.filter((agent) => agent.paymentAgentID === value)[0]
            );
          }}
        >
          {paymentAgents
            .filter((agent) => agent.agentType === "online")
            ?.map((agent) => {
              return (
                <Radio
                  key={agent?.paymentAgentID}
                  value={agent?.paymentAgentID}
                  classNames={{
                    base: cn(
                      " m-0 bg-content1 w-full items-center justify-between !max-w-none",
                      "flex-row-reverse cursor-pointer rounded-lg gap-4 p-4 border-2 border-[var(--main-border-color)]",
                      "data-[selected=true]:border-primary"
                    ),
                  }}
                >
                  {agent.agentType !== "online1" &&
                    agent.useOnline?.profileType === "vivaSmartCheckout" ? (
                    <div className="flex flex-row gap-2">
                      {getName(agent.name)}
                      <img
                        src="https://cdn.okeoke.io/brands/global/payments/Viva-Wallet.png"
                        height="26px"
                        alt="viva"
                        className="h-[26px]"
                      />
                    </div>
                  ) : (
                    <div>{getName(agent.name)}</div>
                  )}
                  <PaymentAgentParams
                    selected={
                      +selectedPayment?.paymentAgentID === +agent.paymentAgentID
                    }
                    data={agent}
                  />
                </Radio>
              );
            })}
        </RadioGroup>
      </div>

      <div className="start-payment">
        {orderNumber != null && (
          <div className="order-number">
            #{orderNumber} {getValue("app_v2_order")}
          </div>
        )}
        <div className="payment-row">
          <div className="label">{getValue("app_v2_payment_totalPrice")}:</div>
          <div className="value">
            <NumericFormat
              value={+totalPrice}
              decimalSeparator=","
              suffix=" Ft"
              thousandSeparator="."
              displayType="text"
            />
          </div>
        </div>
        <div className="payment-row">
          <div className="label">
            {getValue("app_v2_payment_discountAmount")}:
          </div>
          <div className="value">
            <NumericFormat
              value={+discountAmount}
              decimalSeparator=","
              suffix=" Ft"
              thousandSeparator="."
              displayType="text"
            />
          </div>
        </div>
        <div className="payment-row">
          <div className="label">
            {getValue("app_v2_payment_paymentsNeeded")}:
          </div>
          <div className="value">
            <NumericFormat
              value={+paymentsNeeded}
              decimalSeparator=","
              suffix=" Ft"
              thousandSeparator="."
              displayType="text"
            />
          </div>
        </div>
        {hideStartPayment == null && (
          <div
            className="btn hidden-content appear"
            onClick={navigateToPayment}
          >
            {getValue("app_v2_startPayment")}
          </div>
        )}
      </div>
    </div>
  );
}

export default PayTheOfflineOrder;
